const HEX_COR = /^#[0-9A-Fa-f]{6}$/;

export type DistribuicaoVolumetria = {
  readonly reels: number;
  readonly carrossel: number;
  readonly estatico: number;
  readonly stories: number;
};

/** Converte texto separado por virgula em lista de cores hex validas. */
export function parsePaletaHex(texto: string):
  | { readonly ok: true; readonly cores: readonly string[] }
  | { readonly ok: false; readonly erro: string } {
  const partes = texto
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean);

  if (partes.length === 0) {
    return { ok: true, cores: [] };
  }

  const invalidas = partes.filter((cor) => !HEX_COR.test(cor));
  if (invalidas.length > 0) {
    return {
      ok: false,
      erro: `Cor hex invalida: ${invalidas.join(", ")}. Use formato #RRGGBB.`,
    };
  }

  return { ok: true, cores: partes };
}

/** Retorna mensagem se a soma dos formatos nao bater com o total. */
export function validarSomaVolumetria(
  total: number,
  distribuicao: DistribuicaoVolumetria,
): string | null {
  const soma =
    distribuicao.reels +
    distribuicao.carrossel +
    distribuicao.estatico +
    distribuicao.stories;
  if (soma !== total) {
    return `A soma (${soma}) precisa ser igual ao total mensal (${total}).`;
  }
  return null;
}
